import { FC, PropsWithChildren } from 'react';

import { HttpError } from '@bonusly/http';
import { Permission, usePermission } from '@bonusly/who-am-i';

type RequirePermissionProps = PropsWithChildren & {
	permission: Permission;
	/** HTTP status when user lacks permission (default 403). Use 404 to hide the resource. */
	statusCode?: number;
};

/**
 * Renders children only when the current user has the given permission.
 * Otherwise throws HttpError with the given statusCode (default 403).
 * Use for route-level enforcement of plan/feature permissions (e.g. CanViewExpandedReporting).
 */
export const RequirePermission: FC<RequirePermissionProps> = ({ children, permission, statusCode = 403 }) => {
	const hasPermission = usePermission(permission);

	if (hasPermission) {
		return <>{children}</>;
	}

	throw new HttpError(statusCode);
};
